/* eslint-disable no-underscore-dangle */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
// eslint-disable-next-line import/no-extraneous-dependencies
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import Drawer from '@material-ui/core/Drawer';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import { Container } from '@material-ui/core';
import { connect } from 'react-redux';
import { Loading } from '../../helpers/utils';

import MenuCustomerMW from './components/MenuCustomerMW';
import MenuCustomerEW from './components/MenuCustomerEW';
import MenuStudent from './components/MenuStudent';
import MenuTeacher from './components/MenuTeacher';

import { userActions } from '../../redux/actions/userActions';
import { uiActions } from '../../redux/actions/uiActions';
import placementTestServices from '../../redux/services/placementTestServices';
import LanguageSelector from './components/LanguageSelector';

const drawerWidth = 240;

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerHeader: {
    display: 'flex',
    flexGrow: 1,
    alignItems: 'center',
    paddingLeft: '1em',
    ...theme.mixins.toolbar,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  openTitle: {
    flexGrow: 1,
    marginLeft: '250px',
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3),
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    marginLeft: -drawerWidth,
  },
  contentShift: {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  },
  hide: {
    display: 'none',
  },
}));

const Layout = ({
  pageTitle, logout, company, children, infoSheet, user,
}) => {
  const [open, setOpen] = useState(true);
  const [loading, setLoading] = useState(true);

  const isInfoSheet = !!(infoSheet.status === 'created'
    || infoSheet.status === 'in progress'
    || infoSheet.status === 'completed');

  useEffect(() => {
    setOpen(!isInfoSheet);
  }, [isInfoSheet]);

  const classes = useStyles();
  const history = useHistory();

  useEffect(() => {
    if (user !== undefined && user.type !== undefined) {
      if (user.type === 4 && (user.placementtest || user.placementtest === undefined)) {
        placementTestServices.getTest(user._id)
          .then((res) => {
            if (!res || (res && (!res.scores || res.answers.length < 60))) {
              history.push('/placementtest');
            }
            setLoading(false);
          })
          .catch(() => {
            setLoading(false);
          });
      } else {
        setLoading(false);
      }
    }
  }, [user]);

  const location = useLocation();

  return (
    loading === false
      ? (
        <div className={classes.root}>
          <AppBar
            position="fixed"
            style={{
              width: '100%',
            }}
            className={clsx(classes.appBar, {
              [classes.appBarShift]: open,
            })}
          >
            <Toolbar>
              <IconButton
                edge="start"
                color="inherit"
                aria-label="menu"
                className={clsx(classes.menuButton, open && classes.hide)}
                onClick={() => setOpen(true)}
              >
                {!isInfoSheet && <MenuIcon /> }
              </IconButton>
              <Typography variant="h6" className={open ? classes.openTitle : classes.title}>
                { pageTitle }
              </Typography>
              {user?.type === 4 && <LanguageSelector user={user} />}
              <Button onClick={() => logout()} color="inherit">Se deconnecter</Button>
            </Toolbar>
          </AppBar>
          <Drawer
            className={classes.drawer}
            variant="persistent"
            anchor="left"
            style={{
              display: location.pathname.substring(location.pathname.lastIndexOf('/') + 1) === 'placementtest' ? 'none' : 'flex',
            }}
            open={open}
            classes={{
              paper: classes.drawerPaper,
            }}
          >
            { user && user.type === 2 && user.isEW === false
            && <MenuCustomerMW handleDrawerClose={() => setOpen(false)} company={company} />}
            { user && user.type === 2 && user.isEW
            && <MenuCustomerEW handleDrawerClose={() => setOpen(false)} company={company} />}
            {user && user.type === 4
            && <MenuStudent handleDrawerClose={() => setOpen(false)} user={user} />}
            {user && user.type === 3
            && <MenuTeacher handleDrawerClose={() => setOpen(false)} user={user} />}
          </Drawer>
          <main
            className={clsx(classes.content, {
              [classes.contentShift]: open,
            })}
          >
            <div className={classes.drawerHeader} />
            <Container fixed maxWidth="xl">
              {children}
            </Container>
          </main>
        </div>
      )
      : <Loading />
  );
};

Layout.propTypes = {
  pageTitle: PropTypes.string.isRequired,
  logout: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

function mapState(state) {
  const { pageTitle } = state.ui;
  const { company } = state.company;
  const { user } = state.user;
  const { infoSheet } = state.infoSheet;
  const { isTest } = state.authentication;

  return {
    pageTitle,
    company,
    infoSheet,
    user,
    isTest,
  };
}

const actionCreators = {
  logout: userActions.logout,
  changePageTitle: uiActions.changePageTitle,
};

const connectedLayout = connect(mapState, actionCreators)(Layout);
export default connectedLayout;
